import React from "react";
//import { render } from "react-dom";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ThroughProvider } from "react-through";
import "./i18n";
import Routes from "./routes";
import store from "./store";
import "./index.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ThroughProvider>
      <Routes />
    </ThroughProvider>
  </Provider>,
  document.getElementById("root")
);
